import styled from 'styled-components';

export const Container = styled.div``;

export const Title = styled.p`
  margin-top: 4px;
  font: 16px Montserrat;
  font-weight: 500;
  line-height: 24px;
  color: #555658;
`;

export const Subtitle = styled.p`
  font: 14px Montserrat;
  font-weight: 500;
  line-height: 22px;
  color: #898b8e;
`;
